import axios from 'axios';

import { IRequestConfig, MethodsTypes } from 'models/Axios';
import { ILotProduct, IProduct } from '../pages/OpenProtocol/LotProduct/interface';
import Services from './index.service';

export default class LotService extends Services<ILotProduct, ILotProduct> {

  public async autoComplete(str: string, product: IProduct) {
    const config: IRequestConfig<any> = {
      url: `${this.base_url}/lots/autocomplete`,
      method: MethodsTypes.get,
      headers: {
        Authorization: `Bearer ${this.access_token()}`,
      },
      params: {
        sentence: str.toUpperCase(),
        enterpriseCode:product.enterpriseCode,
        productCode:product.code
      },
    };

    return await axios(config)
      .then((result) => result.data)
      .catch((err) => []);
  }

}
